import React from "react";
import { createBrowserRouter, Link, RouterProvider } from "react-router-dom";

import { AnalyticsPath, AppRouteBase, AssetsPath, AuthRouteBase, CollectionsPath, CommonRouteBase, ConfigurationsPath, EditorPath, EventsPath, HelpPath, JobsPath, OverviewPath, ReportsPath, RolesPath, SetPasswordPath, SignInPath, SignOutPath, StoriesPath, TagsPath, TemplatesPath, ToolsPath, TwoFAPath, UsersPath, } from "../utils/routes";

import AppLayout from "../components/layouts/AppLayout";
import AuthLayout from "../components/layouts/AuthLayout";
import PageContainer from "../components/ui/PageContainer";

import SetPasswordPage from "../pages/auth/SetPasswordPage";
import SignInPage from "../pages/auth/SignInPage";
import SignOutPage from "../pages/auth/SignOutPage";
import Two2FAPage from "../pages/auth/TwoFAPage";

import ConfigurationsPage from "@cms/pages/app/ConfigurationsPage";
import AssetsPage from "../pages/app/AssetsPage";
import CollectionsPage from "../pages/app/CollectionsPage";
import EditorPage from "../pages/app/EditorPage";
import EventsPage from "../pages/app/EventsPage";
import HelpPage from "../pages/app/HelpPage";
import JobsPage from "../pages/app/JobsPage";
import OverviewPage from "../pages/app/OverviewPage";
import ReportsPage from "../pages/app/ReportsPage";
import RolesPage from "../pages/app/RolesPage";
import StoriesPage from "../pages/app/StoriesPage";
import TagsPage from "../pages/app/TagsPage";
import TemplatesPage from "../pages/app/TemplatesPage";
import ToolsPage from "../pages/app/ToolsPage";
import UsersPage from "../pages/app/UsersPage";

interface Props { }

const AppRouterProvider: React.FC<Props> = () => {
    const router = createBrowserRouter([
        {
            path: CommonRouteBase,
            element: <AppLayout />,
            children: [
                {
                    path: CommonRouteBase,
                    element: <OverviewPage />
                }
            ]
        },
        {
            path: AuthRouteBase,
            element: <AuthLayout />,
            children: [
                {
                    path: SignInPath,
                    element: <SignInPage />
                },
                {
                    path: SignOutPath,
                    element: <SignOutPage />
                },
                {
                    path: SetPasswordPath,
                    element: (
                        <SetPasswordPage />
                    )
                },
                {
                    path: TwoFAPath,
                    element: <Two2FAPage />
                },
            ]
        },
        {
            path: AppRouteBase,
            element: <AppLayout />,
            children: [
                {
                    path: OverviewPath,
                    element: (
                        <OverviewPage />
                    ),
                },

                {
                    path: RolesPath,
                    element: (
                        <RolesPage />
                    )
                },
                {
                    path: UsersPath,
                    element: (
                        <UsersPage />
                    )
                },
                {
                    path: JobsPath,
                    element: (
                        <JobsPage />
                    )
                },

                // {
                //     path: SubtypesPath,
                //     element: (
                //         <SubtypesPage />
                //     )
                // },
                // {
                //     path: VerticalsPath,
                //     element: (
                //         <VerticalsPage />
                //     )
                // },
                {
                    path: TagsPath,
                    element: (
                        <TagsPage />
                    )
                },

                {
                    path: AssetsPath,
                    element: (
                        <AssetsPage />
                    )
                },
                {
                    path: StoriesPath,
                    element: (
                        <StoriesPage />
                    )
                },
                {
                    path: EditorPath,
                    element: (
                        <EditorPage />
                    )
                },
                {
                    path: CollectionsPath,
                    element: (
                        <CollectionsPage />
                    )
                },
                {
                    path: EventsPath,
                    element: (
                        <EventsPage />
                    )
                },
                {
                    path: ReportsPath,
                    element: (
                        <ReportsPage />
                    )
                },
                {
                    path: TemplatesPath,
                    element: (
                        <TemplatesPage />
                    )
                },

                {
                    path: AnalyticsPath,
                    element: (
                        <PageContainer>
                            <p>Analytics</p>
                        </PageContainer>
                    )
                },
                {
                    path: ToolsPath,
                    element: (
                        <ToolsPage />
                    )
                },
                {
                    path: ConfigurationsPath,
                    element: (
                        <ConfigurationsPage />
                    ),
                },
                {
                    path: HelpPath,
                    element: (
                        <HelpPage />
                    )
                },
                {
                    index: true,
                    element: <OverviewPage />
                },
                {
                    path: '*',
                    element: (
                        <PageContainer isFullHeight>
                            <p
                                className="text-2xl text-red-500"
                            >
                                404 Page Not Found
                            </p>
                            <Link
                                className="text-blue-500"
                                to={OverviewPath}
                            >
                                Go to Home page
                            </Link>
                        </PageContainer>
                    )
                }
            ],
        },
        {
            path: '*',
            element: (
                <PageContainer isFullHeight>
                    <p>404 Page Not Found</p>
                </PageContainer>
            )
        }
    ]);

    return (
        <RouterProvider router={router} />
    )
}

export default AppRouterProvider